module.exports = __webpack_public_path__ + "img/INTERIOR-JIMNY-3.65114d1b.jpg";